import wisdom from '../images/workshop_images/wisdom.png';
import science_backed from '../images/workshop_images/science_backed.png';
import holistic from '../images/workshop_images/holistic.png';
import expert from '../images/workshop_images/expert.png';
import support from '../images/workshop_images/support.png';
import learn01 from '../images/workshop_images/learn01.png';
import learn02 from '../images/workshop_images/learn02.png';
import learn03 from '../images/workshop_images/learn03.png';
import health_seekers from '../images/workshop_images/health_seekers.png';
import working from '../images/workshop_images/working.png';
import homemakers from '../images/workshop_images/homemakers.png';
import student from '../images/workshop_images/student.png';
import parents from '../images/workshop_images/parents.png';
import teenagers from '../images/workshop_images/teenage.png';

export const staticHost = {
  name: 'Dr.Pragati Jain',
  profile_photo: '/images/prgati_jain.png',
  biography:
    'Dr. Pragati Jain is a passionate advocate of natural living, seamlessly blending ancient wisdom with modern science using cutting-edge technology. With a Ph.D. in Computational Neuroscience, Pragati has spent the last three years expanding her knowledge as a Nature Cure practitioner, while also pursuing formal studies in Naturopathy. As a leader in the field of artificial intelligence, she brings a unique, data-driven approach to holistic health.\n\nHer personal journey includes running several half marathons across various locations in India, further fueling her dedication to a balanced and healthy lifestyle. Pragati’s multi-disciplinary expertise equips her to guide others toward achieving optimal health through sustainable practices and informed choices.',
  local: true,
};

export const staticIsThisYou = {
  tagline: 'Is This You?',
  questions: [
    'Worried about medicine side effects and dependency?',
    'Confused by too much health advice and unsure where to start?',
    'Looking for natural, non-violent, and eco-friendly ways to heal?',
    'Want to uncover the root cause of your health issues and find lasting solutions?',
  ],
};

export const staticWhyJoin = [
  {
    id: 'wj-1',
    title: 'Ancient Wisdom',
    tagline: 'Naturopathy and Jain philosophies made practical.',
    logo: wisdom,
    local: true,
  },
  {
    id: 'wj-2',
    title: 'Science-Backed',
    tagline: 'Proven insights you can trust.',
    logo: science_backed,
    local: true,
  },
  {
    id: 'wj-3',
    title: 'Holistic Approach',
    tagline: 'Focus on Body, Mind, Soul, and Sustainability',
    logo: holistic,
    local: true,
  },
  {
    id: 'wj-4',
    title: 'Expert Driven',
    tagline:
      'Live-session led by a Nature Cure practitioner, Neuroscientist, & Data Science Leader',
    logo: expert,
    local: true,
  },
  {
    id: 'wj-5',
    title: 'Personalized Support',
    tagline: 'Tailored advice via Anuyog Consultancy.',
    logo: support,
    local: true,
  },
];

export const staticWhatYoullLearn = [
  {
    id: 'wl-1',
    title: 'Why Use Natural Resources to Heal Yourself?',
    description:
      "Understand the foundational reasons behind the power of nature's remedies.",
    logo: learn01,
    local: true,
  },
  {
    id: 'wl-2',
    title: 'What Are the Natural Healers?',
    description:
      'Explore different types of natural healers and what science has to say about their benefits.',
    logo: learn02,
    local: true,
  },
  {
    id: 'wl-3',
    title: 'How to Use Natural Healers in Your Health Journey?',
    description:
      'Discover how to incorporate these natural healers into your everyday life—from the comfort of your home.',
    logo: learn03,
    local: true,
  },
];

export const staticWhoIsThisFor = [
  {
    id: 'wf-1',
    title: 'For Health Seekers',
    tagline: 'Aiming to improve their overall well-being.',
    logo: health_seekers,
    local: true,
  },
  {
    id: 'wf-2',
    title: 'For Working Professionals',
    tagline: 'Simplify your busy life and prioritize your health.',
    logo: working,
    local: true,
  },
  {
    id: 'wf-3',
    title: 'For Homemakers',
    tagline: 'Take time for yourself while supporting your family.',
    logo: homemakers,
    local: true,
  },
  {
    id: 'wf-4',
    title: 'For Students',
    tagline: 'Enhance focus, energy, and personal growth.',
    logo: student,
    local: true,
  },
  {
    id: 'wf-5',
    title: 'For Parents',
    tagline: 'Pass on lifelong healthy habits to your kids.',
    logo: parents,
    local: true,
  },
  {
    id: 'wf-6',
    title: 'For Teenagers',
    tagline: 'Build strong foundations for a healthier future.',
    logo: teenagers,
    local: true,
  },
];

/** Resolve logo/photo for API paths or local/static assets. */
export function resolveAssetUrl(item, field, baseURL, fallback) {
  if (!item) return fallback;
  const value = item[field];
  if (!value) return fallback;
  if (item.local) return value;
  if (
    typeof value === 'string' &&
    (value.startsWith('http://') ||
      value.startsWith('https://') ||
      value.startsWith('/static/') ||
      value.startsWith('/images/'))
  ) {
    return value;
  }
  const mediaBase = (
    process.env.REACT_APP_MEDIA_BASE_URL ||
    baseURL ||
    'https://admin.anuyog.co'
  ).replace(/\/$/, '');
  const path = String(value).replace(/^\/+/, '');
  return `${mediaBase}/${path}`;
}
